import Axios from '@/plugins/axios'
import {onlineUrl,payUrl} from '@/utils/config.js'
// 获取当前会员身份
export function getSearchPermission() {
  return Axios({
    method: 'GET',
    url: onlineUrl+'/seamark/buyer/get-search-permission',
  })
}

// 点击实名认证
export function applySearchPermission(data) {
  return Axios({
    method: 'POST',
    url: '/seamark/buyer/apply-search-permission',
    data
  })
}

// 点击去实名认证
export function setEsignOrgAuth(data) {
  return Axios({
    method: 'POST',
    url: payUrl + '/pay/esign/org/auth',
    data,
    noMessage: true,
  })
}

// 开通试用
export function setOrderProductTrial(data) {
  return Axios({
    method: 'POST',
    url: '/order-api/trial',
    data,
    noMessage: true,
  })
}

// 查询是否认证
export function getAuthenticationStatus(data) {
  return Axios({
    method: 'POST',
    url: payUrl + '/pay/esign/org/auth/find',
    data,
  })
}